import { Route, Switch } from 'react-router-dom'

import Error404 from '../ui/views/errors/Error404'

import HomeMobile from '../context/HomeMobile'
import ShippingDetail from '../context/ShippingDetail'
import ShippingSendMobile from '../context/ShippingSendMobile'

import * as routes from '../routes'

const MobileRouter = () => {
  return (
    <Switch>
      <Route exact path={routes.HOME.path}>
        <HomeMobile />
      </Route>
      <Route exact path={routes.SHIPPING_DETAIL.path}>
        <ShippingDetail />
      </Route>
      <Route exact path={routes.SHIPPING_SEND.path}>
        <ShippingSendMobile />
      </Route>
      <Route component={Error404} />
    </Switch>
  )
}

export default MobileRouter
